import { render, staticRenderFns } from "./EditorHeaderShareButton.vue?vue&type=template&id=4bdbee06&scoped=true&"
import script from "./EditorHeaderShareButton.vue?vue&type=script&lang=js&"
export * from "./EditorHeaderShareButton.vue?vue&type=script&lang=js&"
import style0 from "./EditorHeaderShareButton.vue?vue&type=style&index=0&id=4bdbee06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdbee06",
  null
  
)

export default component.exports